export default __webpack_public_path__ + "static/media/2.97319235.png";